<shared-search-form [isAutocompleteLocationsEnabled]="isAutocompleteEnabled$ | async" [isDelivery]="isDelivery$ | async"
    class="search-for-locations-filter" [disabled]="!(hasLocations$ | async)" [value]="searchInput$ | async"
    [enableSubmit]="enableSubmit" [enableClear]="enableClear" [placeholder]="placeholder" (onSearch)="onSearch($event)"
    (onSearchReset)="onSearchReset($event)" mode="filter"></shared-search-form>
